import React from 'react';
import PropTypes from 'prop-types';
import { openModal } from 'Helpers/ModalHelper';
import modalConsts from 'Consts/ModalNames';
import useEventTrackingLogEvent, { categories, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { SecondaryActionButton } from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import Relationship from 'facet-rest/src/domain/Relationship';

const ScheduleMeetingButton = ({
  label,
  scheduleRelationship,
}) => {
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const handleClick = () => {
    logStandardizedEvent(categories.clientDashboard, eventTypes.clickButton, 'schedule your first call');
    openModal(modalConsts.clientSchedulerModal, [{
      link: scheduleRelationship.link('related').url(),
    }]);
  };

  return (
    <SecondaryActionButton
      onClick={handleClick}
      label={label}
      isFullWidth
      {...dataAttrs('schedule-meeting-button')}
    />
  );
};

ScheduleMeetingButton.defaultProps = {
  label: 'Schedule Your Next Call',
};

ScheduleMeetingButton.propTypes = {
  label: PropTypes.string,
  scheduleRelationship: PropTypes.instanceOf(Relationship).isRequired,

};

export default ScheduleMeetingButton;
